import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { metadata } from '../seo/metadata';

export default function Seo() {
  const { pathname } = useLocation();
  useEffect(() => {
    const data = metadata(pathname);
    document.title = data.title;
    const setMeta = (attribute, key, content) => {
      let element = document.head.querySelector(`meta[${attribute}="${key}"]`);
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, key);
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    };
    setMeta('name', 'description', data.description);
    setMeta('name', 'robots', data.robots);
    for (const [key, value] of Object.entries({ title: data.title, description: data.description, url: data.url, image: data.image, type: 'website', site_name: 'ELARITECH', locale: 'es_AR', 'image:alt': 'Logo de ELARITECH' })) setMeta('property', `og:${key}`, value);
    for (const [key, value] of Object.entries({ card: 'summary', title: data.title, description: data.description, image: data.image, 'image:alt': 'Logo de ELARITECH' })) setMeta('name', `twitter:${key}`, value);
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) { canonical = document.createElement('link'); canonical.rel = 'canonical'; document.head.appendChild(canonical); }
    canonical.href = data.url;
    let schema = document.getElementById('seo-schema');
    if (!schema) { schema = document.createElement('script'); schema.id = 'seo-schema'; schema.type = 'application/ld+json'; document.head.appendChild(schema); }
    schema.textContent = JSON.stringify(data.schema);
  }, [pathname]);
  return null;
}
